import articleStyles from '../../styles/Article.module.css'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ArticleTagsRead from './ArticleTagsRead'
import changeDateFormat from '../utils'
import Image from 'next/image'
import Link from 'next/link'
import { cloudfront } from '../../config'
import { supabase } from "../../utils/supabaseClient"
import { useEffect } from 'react'
import dynamic from 'next/dynamic'
import ArticleContent from './ArticleContent'


const Comments = dynamic(() => import('../Comments'))
const ArticleTagList = dynamic(() => import('./ArticleTagList'))

export default function ArticlePost({article, handleRegisterModal}) {


    useEffect(() => {
        async function incrementCount() {
            const row_id = article.id 
            const {data, error} = await supabase
                .rpc('increment_article_count', {
                    row_id
                })
            error && console.log(error)
        }

          incrementCount()
    }, [])

    return (
        <div className="pe-lg-2">
            {/* Title, published date, and tags */}
            <h1 className={articleStyles.title}>{article.article_title}</h1>
            <Row>
                <Col xl={6} lg={12}>
                    <p className={articleStyles.published}>{changeDateFormat(article.article_published)}</p>
                </Col>
                <Col xl={6} lg={12} className="text-start text-xl-end">
                    <ArticleTagsRead
                        article_tags={article.main_tag} 
                        reading_time={article.reading_time}
                    />
                </Col>
            </Row>

            {/* Cover image */}
            <Image 
                className={articleStyles.cover} 
                src={`${cloudfront}/media/${article.article_image}`} 
                width={759} 
                height={350} 
                layout="responsive" 
                objectFit="cover" 
                alt={article.article_title}
                priority 
            />
            <div id="ezoic-pub-ad-placeholder-104"> </div>
            {/* mobile written by */}
            <div className="my-3">
                <div className={articleStyles.mobile_author}>
                    <Link href={`/blog/${article.main_profile.username}`} passHref>
                        <a className={articleStyles.animate}>
                            <div className="d-flex text-start">
                                {article.main_profile.user_image &&
                                    <Image className={`mr-3 ${articleStyles.mobile_author}`} 
                                    src={`${cloudfront}/${article.main_profile.user_image}`} 
                                    width={50}
                                    height={50} 
                                    objectFit="cover"
                                    alt={article.main_profile.username}
                                    />
                                }
                                    <div className={article.main_profile.user_image ? `ps-3 ${articleStyles.mobile_author_info}` : articleStyles.mobile_author_info}>
                                        <p className={articleStyles.written_by}>Written By</p>
                                        <h6 className={articleStyles.author}>{article.main_profile.username}</h6>
                                    </div>
                            </div>
                        </a>
                    </Link>
                </div>
            </div>


            {/* last modified */}
            <div className="mb-3">
                {article.last_modified && 
                        <p className={articleStyles.published}>Last Modified: {changeDateFormat(article.last_modified)}</p>
                }
            </div>
                
            {/* article content */}
            <ArticleContent 
                content={article.test_content}
            />
            {/* <div className={articleStyles.content} dangerouslySetInnerHTML={{ __html: article.article_content }}>
            </div> */}

            {/* Related projects */}
            {/* <RelatedProjectsList projects={articles.projects} /> */}

            {/* Article tags and Follow us on Twitter*/}
            <Container className="py-4 px-0">
                <Row className="g-0">
                  <Col className="my-auto" lg={6} md={12}>
                      <ArticleTagList article_tags={article.main_tag} />
                  </Col> 
                  <Col lg={6} md={12} className='text-start text-lg-end'>
                        <p className={articleStyles.follow_us}>
                          Follow us 
                          <Link href="https://twitter.com/OrdinaryCoders" passHref>
                            <Button variant="link" className="px-1">
                                @ordinarycoders
                            </Button>
                          </Link>
                        </p>
                  </Col>
                </Row>
            </Container>


            {/* Comment Form */}
            <div id="ezoic-pub-ad-placeholder-102"> </div>
            <Comments
                type="article"
                parent_id={article.id}
                handleRegisterModal={handleRegisterModal}
            />

        </div>
    )
}